module.exports = __webpack_public_path__ + "img/position-4.e14d8000.png";